export default __webpack_public_path__ + "static/media/AdCave_01.ccbfc16b.png";